import React, { useEffect } from 'react';

const Slider = ({ show, children, onHide = () => {}, reversed, focusElement, className, classes, disableBackingClick = false }) => {
  const handleWindowKeydown = (e) => {
    if (e.key === 'Escape') {
      onHide();
    }
  };

  useEffect(() => {
    if (focusElement && show) {
      setTimeout(() => {
        const input = document.querySelector(focusElement);
        if (input) {
          input.focus();
          input.focus();
          input.focus();
          input.focus();
        }
      }, 100);
    }
  }, [show]);

  useEffect(() => {
    window.addEventListener('keydown', handleWindowKeydown);
    return () => window.removeEventListener('keydown', handleWindowKeydown);
  }, []);

  return (
    <div className={`slider-component ${show ? 'active' : ''} ${reversed ? 'reversed' : ''} ${className || ''}`}>
      <div className="slider-backing" onClick={(e) => (!disableBackingClick ? onHide(e) : null)} />
      <div className={`slider-content ${classes ? classes : ''}`}>{children}</div>
    </div>
  );
};

export default Slider;
